import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import FormIcon from '@atlaskit/icon/core/form';
import LockLockedIcon from '@atlaskit/icon/core/migration/lock-locked--lock-filled';
import { FormCardIcon as LegacyFormCardIcon } from '@atlaskit/legacy-custom-icons';
import { fg } from '@atlaskit/platform-feature-flags';
import { N800, R400 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import { FormRestrictionStatus } from '@atlassian/proforma-form-security';
import { ActionSubject } from '@atlassian/proforma-utils/analytics';
import { messages } from './messages';
export const FormCardIcon = ({
  restrictionStatus,
  isSelecting
}) => {
  const getFormLockedIcon = () => {
    const lockedIcon = /*#__PURE__*/React.createElement(LockLockedIcon, {
      color: isSelecting ? `var(--ds-icon-accent-red, ${R400})` : `var(--ds-icon, ${N800})`,
      spacing: "spacious",
      label: ""
    });
    return !isSelecting ? /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(FormattedMessage, messages.restrictedFormIconTooltip),
      onShow: analyticsEvent => {
        fireUIAnalytics(analyticsEvent, ActionSubject.FORM_PERMISSIONS);
      }
    }, lockedIcon) : lockedIcon;
  };
  return restrictionStatus === FormRestrictionStatus.RESTRICTED ? getFormLockedIcon() : /*#__PURE__*/React.createElement(FormIcon, {
    LEGACY_fallbackIcon: LegacyFormCardIcon,
    color: "currentColor",
    label: "",
    spacing: "spacious"
  });
};